<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="center"><span class="red"><strong>TO MY FATHER, HANK, MY MOTHER, JOYCE, <br/>AND MY BROTHER, BRIAN. <br/>I AM ETERNALLY GRATEFUL YOU ARE MY FAMILY. <br/>I LOVE YOU.</strong></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?3670de90